// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","errorMessage":"_1g0KWDHG4QXMOG2eg3dxKi","errorMessageTitle":"_3GD6Co84a3hJRIfeMHDNNI"};